export const getStrictnessLabel = (threshold: number): string => {
  if (threshold <= 0.3) return 'Loose';
  if (threshold <= 0.6) return 'Balanced';
  return 'Strict';
};
